import onBreakpointChange from '../utils/onBreakpointChange';
import Swiper, { Navigation } from 'swiper';

export default class AnnouncementBarBlock {
  constructor() {
    this.selector = '.b-announcement-bar';

    this.selectors = {
      slider: '.b-announcement-bar__body',
      wrapper: '.b-announcement-bar__items',
      slide: '.b-announcement-bar__item',
    };

    this.swiperClasses = {
      slider: 'swiper',
      wrapper: 'swiper-wrapper',
      slide: 'swiper-slide',
      sliderMobile: [ 'b-announcement-bar-style-default' ],
      blockInactiveSlider: 'b-announcement-bar--inactive-slider',
    };

    this.swipers = [];
  }

  bootstrap() {
    const blocks = this.getBlocks();
    const sliderItems = document.querySelectorAll(this.selectors.slide).length;

    if (blocks.length === 0 || sliderItems < 2) {
      return;
    }

    blocks.forEach(block => {
      onBreakpointChange(767, () => {
        this.init(block);
      }, 'down');

      onBreakpointChange(768, () => {
        if (document.querySelectorAll(this.selectors.slide).length > 3) {
          this.init(block);
        } else {
          this.removeSwiperClasses(block);
          this.destroySwiper(block);
        }
      });
    });
  }

  init(block) {
    this.addSwiperClasses(block);
    this.appendActions(block);

    const swiper = this.initSwiper(block);

    this.swipers.push({
      id: block.getAttribute('id'),
      swiper,
    });
  }

  getBlocks() {
    return [ ...document.querySelectorAll(this.selector) ];
  }

  isMobileSlider(block) {
    return this.swiperClasses.sliderMobile.some(className => block.classList.contains(className));
  }

  addSwiperClasses(block) {
    const slider = block.querySelector(this.selectors.slider);
    const wrapper = block.querySelector(this.selectors.wrapper);
    const slides = [ ...block.querySelectorAll(this.selectors.slide) ];

    slider.classList.add(this.swiperClasses.slider);
    wrapper.classList.add(this.swiperClasses.wrapper);
    slides.forEach(slide => slide.classList.add(this.swiperClasses.slide));
  }

  removeSwiperClasses(block) {
    const slider = block.querySelector(this.selectors.slider);
    const wrapper = block.querySelector(this.selectors.wrapper);
    const slides = [ ...block.querySelectorAll(this.selectors.slide) ];

    slider.classList.remove(this.swiperClasses.slider);
    wrapper.classList.remove(this.swiperClasses.wrapper);
    slides.forEach(slide => {
      slide.classList.remove(this.swiperClasses.slide);
      slide.removeAttribute('style');
    });
  }

  destroySwiper(block) {
    const blockId = block.getAttribute('id');
    const swiper = this.swipers.find(item => item.id === blockId);

    block.classList.add(this.swiperClasses.blockInactiveSlider);

    if (swiper) {
      swiper.swiper.destroy(true, true);

      this.removeActions(block);
    }
  }

  initSwiper(block) {
    const sliderElement = block.querySelector(this.selectors.slider);

    if (!sliderElement) {
      return;
    }

    return new Swiper(sliderElement, {
      modules: [ Navigation ],
      slidesPerView: 1,
      spaceBetween: 15,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints: {
        1024: {
          slidesPerView: 3,
        },
      },
    });
  }

  appendActions(block) {
    const slider = block.querySelector(this.selectors.slider);
    const sliderActions = block.querySelector('.b-announcement-bar_actions');

    if (sliderActions) {
      return;
    }

    const html = `
      <div class="b-announcement-bar__actions">
        <div class="swiper-button swiper-button-prev">
          <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="25" cy="25" r="24.5" transform="rotate(-180 25 25)" stroke="#252525"/>
          <path d="M29.5 17L21 25L29.5 32.5" stroke="#252525"/>
          </svg>
        </div>
        <div class="swiper-button swiper-button-next">
          <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="25" cy="25" r="24.5" stroke="#252525"/>
          <path d="M21 32.5L29.5 24.5L21 17" stroke="#252525"/>
          </svg>
        </div>
      </div>
    `;

    slider.insertAdjacentHTML('afterend', html);
  }

  removeActions(block) {
    const sliderActions = block.querySelector(this.selectors.sliderActions);

    if (sliderActions) {
      sliderActions.remove();
    }
  }
}
